import { normalize } from 'normalizr';

import { DismissablePromptsByTypeSchema, dismissablePromptsByTypeSchema } from './schemas/dismissablePromptByType';
import { LoadDismissablePromptsByTypeEntities, NormalizedDismissablePromptsByTypeEntities } from './types';

export const normalizeDismissablePromptsByTypeResponse: LoadDismissablePromptsByTypeEntities = (response) =>
  normalize<DismissablePromptsByTypeSchema, NormalizedDismissablePromptsByTypeEntities>(
    response.data.viewer.dismissablePromptsByType,
    dismissablePromptsByTypeSchema
  ).entities.dismissablePromptsByType;
